/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Event_TemplatesInputs */

const en_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Templates`)
};

const fr_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles d'événements`)
};

const de_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisvorlagen`)
};

const it_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelli di eventi`)
};

const ru_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны мероприятий`)
};

const es_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantillas de eventos`)
};

const zh_cn2_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动模板`)
};

const ja_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテンプレート`)
};

const hi_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेम्प्लेट्स`)
};

const pt_pt2_options_quicktools_event_templates = /** @type {(inputs: Options_Quicktools_Event_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de eventos`)
};

/**
* | output |
* | --- |
* | "Event Templates" |
*
* @param {Options_Quicktools_Event_TemplatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_event_templates = /** @type {((inputs?: Options_Quicktools_Event_TemplatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Event_TemplatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_event_templates(inputs)
	if (locale === "de") return de_options_quicktools_event_templates(inputs)
	if (locale === "it") return it_options_quicktools_event_templates(inputs)
	if (locale === "ru") return ru_options_quicktools_event_templates(inputs)
	if (locale === "es") return es_options_quicktools_event_templates(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_event_templates(inputs)
	if (locale === "ja") return ja_options_quicktools_event_templates(inputs)
	if (locale === "hi") return hi_options_quicktools_event_templates(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_event_templates(inputs)
	return en_options_quicktools_event_templates(inputs)
});